var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridIcons3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1128,
    height: 552,
    viewBox: "0 0 1128 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1128,
    height: 552,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.182 246.897V253.903",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M620.045 299.83V306.835",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M596.884 120.795H672.024V147.969H617.302L608.454 178.159H672.977L656.479 419.704H484.404L472.561 246.854C447.078 241.215 427 219.15 427 191.746C427 160.224 453.054 135.143 484.594 135.143C511.452 135.143 534.321 153.309 540.542 178.159H580.072L596.884 120.795ZM572.109 205.332H497.036L500.249 252.641L555.611 261.622L572.109 205.332ZM563.07 290.358L502.154 280.481L509.832 392.531H631.037L637.176 302.641L563.125 290.372L563.07 290.358ZM639.041 275.413L643.833 205.332H600.477L582.672 266.065L639.041 275.413ZM511.547 178.145C508.913 173.315 505.015 169.29 500.268 166.5C495.521 163.71 490.103 162.259 484.594 162.303C467.565 162.317 454.225 175.754 454.225 191.746C454.225 202.574 460.759 212.438 470.574 217.506L467.892 178.159L511.547 178.145Z",
    fill: "#C8D2D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M487.716 453.955L462.807 99",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M652.738 453.955L677.647 99",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.568 419.705H699.443",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M444.125 307.614H701",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M444.125 246.897H701",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444.125 242.228L697.886 285.818",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M444.125 270.25L699.443 313.841",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M682.768 420.234C682.768 413.322 680.154 406.667 675.451 401.603C670.747 396.539 664.302 393.441 657.409 392.933",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M457.347 419.729C457.347 412.818 459.961 406.162 464.665 401.098C469.368 396.034 475.813 392.937 482.706 392.428",
    stroke: "#058CD7",
    strokeWidth: 1.55682
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcons3);
export default __webpack_public_path__ + "static/media/grid-icons-3.baefe4bab75102e9851e2cf8dd6f683e.svg";
export { ForwardRef as ReactComponent };